import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

import type { TabbedAgentSessionsProps } from './TabbedAgentSessions.tsx';

export const TabbedAgentSessionsLoadable: LoadableType<TabbedAgentSessionsProps> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-TabbedAgentSessions" */ './TabbedAgentSessions.tsx'
			)
		).TabbedAgentSessions,
});
